// extracted by mini-css-extract-plugin
export default {"phone":"MobileView_phone__rEwcZ","iframe":"MobileView_iframe__uk8bu"};